module.exports = __webpack_public_path__ + "img/ap.c35ca0e6.png";